module.exports = __webpack_public_path__ + "img/1-12.a31180a8.png";